import React, { Component } from 'react';
import PropTypes from 'prop-types';

const musicFieldDecorator = (WrappedFieldComponent) => {

  const ENTER_KEY = 13;

  class MusicFieldDecorator extends Component {
    static propTypes = {
      id: PropTypes.number,
      value: PropTypes.string,

    };
    static defaultProps = {

    };

    state = {
      elementId: this.props.id || null,
      currentValue: this.props.value || null,
      elementErrorId: null,
    };

    componentDidUpdate(prevProps) {
      if (prevProps.value !== this.props.value) {
        this.setState({ currentValue: this.props.value });
      }
    }

    onEnterClick = event => {
      if (event.keyCode === ENTER_KEY) {
        if (this.props.id === this.state.elementId) {
          event.target.blur();
        }
      }
    };

    handleInputChange = event => {
      event.preventDefault();
      this.setState({
        elementId: this.props.id,
        currentValue: event.target.value
      });
    };

    handleInputBlur = event => {
      if (event && event.target) {
        this._handleFieldSubmit(this.state.elementId, event.target.value || '');
      }
    };

    _handleFieldSubmit = (linkId, value) => {
      if (value !== this.props.value) {
      // if (this.state.currentValue !== '' && value !== this.props.value) {
        this.setState({
          elementErrorId: linkId,
          currentValue: value,
        }, () => {
          this.props.handleSubmit(linkId, value);
        });
      }
    };

    render() {
      return (
        <WrappedFieldComponent
          {...this.props}
          value={this.state.currentValue}
          onChange={this.handleInputChange}
          onBlur={this.handleInputBlur}
          onKeyDown={this.onEnterClick}
        />
      );
    }
  }

  return MusicFieldDecorator;
};

export default musicFieldDecorator;
